import {ref} from "vue";

const useHeightTransition = () => {

  //表示領域の開閉
  const isOpen = ref(false);

  //開く
  const open = () => {
    isOpen.value = true;
  };

  //閉じる
  const close = () => {
    isOpen.value = false;
  };

  //開閉を反転させる
  const toggle = () => {
    isOpen.value = ! isOpen.value;
  };

  // height でトランジションアニメーションするための関数
  // 下記を参考に実装
  // https://note.com/noliaki/n/n6e3a60748c11

  /**
   * event は HTMLElement か判定
   * @param element
   * @returns {boolean}
   * @private
   */
  const _isHtmlElement = element => element instanceof HTMLElement;

  /**
   * ブラウザが変更した height 値を認識できるまで fn の実行を遅らせる、
   * @param fn
   * @private
   */
  const _nextFrame = callback => {
    window.requestAnimationFrame(() => window.requestAnimationFrame(callback))
  }

  /**
   * enter イベントにフックさせる
   * 高さを 0 から通常の高さにする
   * @param element
   */
  const onEnter = element => {
    //HTMLElement でなければ何もしない
    if ( ! _isHtmlElement(element)) {
      return
    }

    //一旦高さを 0 とする
    element.style.overflow = 'hidden';
    element.style.height = '0';

    //ブラウザに高さを認識させた後、高さを scrollHeight とする
    _nextFrame(() => {
      element.style.height = `${element.scrollHeight}px`
    });
  };

  /**
   * leave イベントにフックさせる
   * 高さを通常の高さから 0 にする
   * @param element
   */
  const onLeave = element => {
    //HTMLElement でなければ何もしない
    if ( ! _isHtmlElement(element)) {
      return
    }

    //一旦高さを scrollHeight とする
    element.style.overflow = 'hidden'
    element.style.height = `${element.scrollHeight}px`

    //ブラウザに高さを認識させた後、高さを 0 にする
    _nextFrame(() => {
      element.style.height = '0'
    })
  };

  /**
   * afterenter, afterleave イベントにフックさせる
   * height と overflow を元に戻す
   * @param element
   */
  const onAfter = element => {
    //HTMLElement でなければ何もしない
    if ( ! _isHtmlElement(element)) {
      return
    }

    //height, overflow を元に戻す
    element.style.height = ''
    element.style.overflow = ''
  };

  //提供
  return {
    isOpen,
    open,
    close,
    toggle,
    onEnter,
    onLeave,
    onAfter
  };

};

//composition のエクスポート
export default useHeightTransition;
